import React from "react";
import ReactDOM from "react-dom/client";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./styles/index.css";
import { colors, fonts } from "./theme";
import NavBar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import Pillars from "./components/Pillars";
import Framework from "./components/Framework";
import Programs from "./components/Programs";
import DepartmentMatrix from "./components/DepartmentMatrix";
import Accreditation from "./components/Accreditation";
import TrainingCards from "./components/TrainingCards";
import ProjectServices from "./components/ProjectServices";
import Impact from "./components/Impact";
import Comparison from "./components/Comparison";
import Roadmap from "./components/Roadmap";
import CampusCard from "./components/CampusCard";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollReveal from "./components/ScrollReveal";

const theme = createTheme({
  palette: {
    primary: { main: colors.blueDark, dark: colors.navy, contrastText: colors.white },
    secondary: { main: colors.pink },
    text: { primary: colors.textBody, secondary: colors.textMuted },
    background: { default: colors.white },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: fonts.body,
    h1: { fontFamily: fonts.heading, fontWeight: 700 },
    h2: { fontFamily: fonts.heading, fontWeight: 700 },
    h3: { fontFamily: fonts.heading, fontWeight: 700 },
    h4: { fontFamily: fonts.heading, fontWeight: 700 },
    h5: { fontFamily: fonts.heading, fontWeight: 600 },
    h6: { fontFamily: fonts.heading, fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 999,
          paddingInline: "22px",
          transition:
            "transform .2s ease, box-shadow .25s ease, background-color .2s ease, opacity .2s ease",
          "&:hover": { transform: "translateY(-2px)" },
          "&:active": { transform: "translateY(0)" },
        },
      },
    },
    MuiCard: { styleOverrides: { root: { backgroundImage: "none" } } },
    MuiCssBaseline: {
      styleOverrides: {
        "@media (prefers-reduced-motion: reduce)": {
          "*": {
            animationDuration: "0.01ms !important",
            transitionDuration: "0.01ms !important",
            scrollBehavior: "auto !important",
          },
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <ScrollReveal />
      <NavBar />
      <Home />
      <About />
      <Pillars />
      <Framework />
      <Programs />
      <DepartmentMatrix />
      <Accreditation />
      <TrainingCards />
      <ProjectServices />
      <Impact />
      <Comparison />
      <Roadmap />
      <CampusCard />
      <Contact />
      <Footer />
    </ThemeProvider>
  </React.StrictMode>
);
